module.exports = __webpack_public_path__ + "img/how11.96a90665.png";